import { Row, Col, Form, Well } from 'react-bootstrap';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withFormik } from 'formik';
import TextInput from './TextInput';
import Button from './Button';
import ConfirmDialog from './ConfirmDialog';
import { caseSetServerError } from '../../actions/caseActions';
import { userSmsRegisterPhone } from './../../actions/userActions';
import { isDemoAccount } from '../../helpers/utils';


class RegisterSmsPhoneForm extends PureComponent {
    constructor(props) {
        super(props);
        this.registerNumber = this.registerNumber.bind(this);
        this.getRegisterButton = this.getRegisterButton.bind(this);
        this.state = { loading: false };
    }

    getRegisterButton() {
        return (
            <Button label="Connect with SMS service"
                    icon="phone"
                    style={{ marginLeft: 15, marginTop: 10 }}
                    loading={this.props.isSubmitting}
                    disabled={this.state.loading || this.props.isSubmitting || isDemoAccount(this.props.loggedIn)}
                    onClick={this.registerNumber}
                    tooltip="Get number from which you will be able to send SMS messages to your clients."
            />
        );
    }

    registerNumber() {
        this.setState({ loading: true });
        this.props.dispatch(userSmsRegisterPhone(this.props.values['Prefix']))
            .then(() => {
                this.setState({ loading: false });
            })
            .catch((error) => {
                console.error(new Error().stack, error);
                this.props.dispatch(caseSetServerError(error));
                this.setState({ loading: false });
            });
    }

    render() {
        const {
            open,
            cancel,
            showAsDialog = false,
            handleChange,
            handleSubmit,
            handleBlur,
            values,
            errors,
            touched,
            loggedIn,
        } = this.props;

        const loading = this.state.loading;
        let output;
        const form = (
            <div>
            <Row>
            <Col xs={12}>
            <Well>(Optional) Fill in the area code (eg. '312', '206', ...) for the number you wish to use. Leaving blank will assign first available number.</Well>
            </Col>
            </Row>
            <Row>
            <Col xs={12}>
            <TextInput field={{
                           name: 'Prefix',
                           onChange: handleChange,
                           onBlur: handleBlur,
                           value: values['Prefix'],
                           error: errors['Prefix'],
                           touched: touched['Prefix'],
                       }}
                       label="Prefix"
                       disabled={loading}
            />
            </Col>
            </Row>
            </div>
        );

        if (loggedIn['PublicSmsPhone']) {
            output = (
                <Form>
                <TextInput field={{
                                name: 'PublicSmsPhone',
                                value: loggedIn['PublicSmsPhone'],
                            }}
                            label="SMS number"
                />
                </Form>
            );
        } else {
            output = (
                <Form onSubmit={handleSubmit}>
                {form}
                <Row>
                <Col xs={12}>
                {this.getRegisterButton()}
                </Col>
                </Row>
                </Form>
            );
        }

        if (showAsDialog) {
            output = (
                <ConfirmDialog title="Connect with SMS service"
                               cancel={cancel}
                               open={open}
                               confirmButton={this.getRegisterButton()}
                >
                {form}
                </ConfirmDialog>
            );
        }

        return output;
    }
}

RegisterSmsPhoneForm.propTypes = {
    open: PropTypes.bool,
    cancel: PropTypes.func,
    showAsDialog: PropTypes.bool,
};

const formikWrapper = {
    mapPropsToValues: props => props.initialValues,
    enableReinitialize: true,
};

const mapStateToProps = (state) => {
    return {
        initialValues: { Prefix: '' },
        loggedIn: state.user.loggedIn,
    };
};


export default connect(mapStateToProps)(withFormik(formikWrapper)(RegisterSmsPhoneForm));
